import { Vocabulary } from "../Vocabulary";
import NoCrashIcon from "@mui/icons-material/NoCrash";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import DashboardIcon from "@mui/icons-material/Dashboard";

// import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';

export const ROUTER_LOGISTICS_DEPARTMENT = {
  routes: [
    "/",
    "/vehiclesDashboard/vehicleDetails/:id?",
    "/vehiclesDashboard",
    "/vehiclesDashboard/:id?",
    "/anaf/notifications",
    "/anaf",
    "/controlPanel",
    "*",
  ],
};

export const MAIN_SLIDER_LOGISTICS_DEPARTMENT = [
  {
    name: Vocabulary.anafTitle,
    path: "/anaf/notifications",
    icon: <AccountBalanceIcon />,
    orderId: 15.5,
    group: Vocabulary.navGroupAdministration,
  },
];

export const VEHICLE_LOGISTICS_DEPARTMENT = [
  {
    name: Vocabulary.dashboard,
    path: `/vehiclesDashboard/vehicleDashboard/`,
    icon: <DashboardIcon />,
    id: "vehicleDashboard",
    orderNumber: 0,
  },
  {
    name: Vocabulary.detaliiVehicul,
    path: "/vehiclesDashboard/vehicleDetails/",
    icon: <NoCrashIcon />,
    id: "vehicleDetails",
    orderNumber: 1,
  },
];

export const DINAMIC_TABS_LOGISTICS_DEPARTMENT = null;

export const MAIN_TABLE_LOGISTICS_DEPARTMENT = { route: "vehicleDetails" };

export const MAIN_HEADER_LOGISTICS_DEPARTMENT = "vehicleDetails";
